/**
 * DisplayItem > Actions object.
 *
 * @typedef {Object} Actions
 * @namespace
 *
 * @memberof Common.Model.Entity.DisplayItem
 *
 * @property {Object} network Object defining available network actions (eg. retweet).
 * @property {Object} profile Object defining available profile actions.
 * @property {Object} platform Object defining available platform actions (eg. voting).
 * @property {Object} sharing Object defining available sharing actions.
 */
class Actions {

	constructor(network, profile, platform, sharing) {

		this.network	= network;
		this.profile	= profile;
		this.platform	= platform;
		this.sharing	= sharing;
	}
}

export default Actions;